export default {"src":"/_next/static/media/KRW.8a986671.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};